<div class="content-wrapper">

    <section class="content-header">
        <h1>
           Proposta
            <small>Gerenciar</small>
        </h1>
        <ol class="breadcrumb">
            <li>
                <a routerLink="/home">
                    <i class="fa fa-home"></i> Home</a>
            </li>
            <li class="active">Proposta</li>
        </ol>
    </section>

    <br>

    <div class="col-md-12">
        <div class="box box-primary">
            <div class="box-header with-border">
                <h3 class="box-title">Gerenciar conteúdo</h3>
            </div>

<!--
            <ng-container *ngIf="auth.temPermissao('ROLE_VISUALIZAR_MENU_AREA_DE_ATUACAO')">
              <button class="btn btn-app" routerLink="area-atuacao/listar" *ngIf="!auth.jwtPayload.proponente" routerLinkActive="btn-app-active">
                <i class="fa fa-clone"></i> <span>Áreas de atuação</span>
              </button>
              <button class="btn btn-app" routerLink="area-atuacao/vincular-proponente"
                *ngIf="auth.jwtPayload.proponente" routerLinkActive="btn-app-active">
                <i class="fa fa-clone"></i> <span>Áreas de atuação</span>
              </button>
            </ng-container>

-->


            <div class="box-body no-padding">
                <div class="col-xs-12">
                    <h3>Opções</h3>
                    <hr>
                    <div class="col-md-12" >
                        <button class="btn btn-app" pTooltip="Gerenciar Convênios" [routerLink]="['convenios']" tooltipPosition="top" routerLink="view"
                        *ngIf="auth.temPermissao('ROLE_ENVIAR_PROPOSTA_CONVENIOS')" routerLinkActive="btn-app-active">
                            <i class="fa fa-retweet"></i> Convênios
                        </button>
                        <button class="btn btn-app" pTooltip="Gerenciar Parcerias" [routerLink]="['parcerias']" tooltipPosition="top" routerLink="view"
                            *ngIf="auth.temPermissao('ROLE_ENVIAR_PROPOSTA_PARCERIAS')" routerLinkActive="btn-app-active">
                            <i class="fa fa-thumbs-up"></i> Parcerias
                        </button>
                        <button class="btn btn-app" pTooltip="Gerenciar Contrato de Gestão" [routerLink]="['contrato']" tooltipPosition="top" routerLink="view"
                        *ngIf="auth.temPermissao('ROLE_ENVIAR_PROPOSTA_CONTRATO_GESTAO')"  routerLinkActive="btn-app-active">
                            <i class="fa fa-file"></i> Contrato de Gestão
                        </button>
                        <button class="btn btn-app" pTooltip="Gerenciar Patrocínio" [routerLink]="['patrocinio']" tooltipPosition="top" routerLink="view"
                        *ngIf="auth.temPermissao('ROLE_ENVIAR_PROPOSTA_PATROCINIO')"  routerLinkActive="btn-app-active">
                            <i class="fa fa-dollar"></i> Patrocínio
                        </button>

                        <button class="btn btn-app" pTooltip="Gerenciar dispensas e inexigibilidades" [routerLink]="['dispensaInegibilidade']" tooltipPosition="top" routerLink="view"
                        *ngIf="auth.temPermissao('ROLE_ENVIAR_PROPOSTA_DISPENSA_INEXIGIBILIDADE')"    routerLinkActive="btn-app-active">
                            <i class="fa fa-list-alt"></i> Dispensa/Inegibilidade
                        </button>

                    </div>
                </div>

                <div class="col-md-12">
                    <hr>
                </div>

                <div class="col-md-12">
                    <router-outlet></router-outlet>
                </div>

                <div class="col-md-12">
                    <hr>
                </div>

            </div>
        </div>


    </div>
